var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.443,
    height: 19.443,
    viewBox: "0 0 19.443 19.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_bank",
    "data-name": "vuesax/bulk/bank",
    transform: "translate(-428 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bank",
    transform: "translate(428 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H3.241V5.671H0Z",
    transform: "translate(3.241 8.911)",
    fill: "#4c1036",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H3.241V5.671H0Z",
    transform: "translate(12.962 8.911)",
    fill: "#4c1036",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H19.443V19.443H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M16.2.81v2.43H0V.81A.813.813,0,0,1,.81,0H15.392A.813.813,0,0,1,16.2.81Z",
    transform: "translate(1.62 14.582)",
    fill: "rgba(76,16,54,0.4)",
    stroke: "#4c1036",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M18.43,1.215H.608A.612.612,0,0,1,0,.608.612.612,0,0,1,.608,0H18.43a.612.612,0,0,1,.608.608A.612.612,0,0,1,18.43,1.215Z",
    transform: "translate(0.203 17.215)",
    fill: "#4c1036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M15.692,2.965,8.4.049a.949.949,0,0,0-.6,0L.51,2.965A.867.867,0,0,0,0,3.718v2.69a.813.813,0,0,0,.81.81H15.392a.813.813,0,0,0,.81-.81V3.718A.867.867,0,0,0,15.692,2.965ZM8.1,5.193A1.215,1.215,0,1,1,9.316,3.978,1.214,1.214,0,0,1,8.1,5.193Z",
    transform: "translate(1.62 1.693)",
    fill: "#4c1036"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.950bac66ae564508a56cd4496204e804.svg";
export { ForwardRef as ReactComponent };